module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.30b3ce82.txt";